import {useState} from 'react'
import { NavLink } from 'react-router-dom';
import googlePlay from '../assets/google-play-store logo.png';
import appStore from '../assets/app-store-logo.png';
import './Navbar.css';
import '../pages/styles.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
     <nav className="navbar">
        <div className="nav-container">
          <a href="/" className="nav-logo">
            <img src='/lutero-icon.png' alt="Lutero Logo" />
          </a>
          
          <div id="nav-links" className={`nav-links ${isOpen ? 'open' : ''}`}>
            <NavLink 
              to="/"
              onClick={closeMenu}
              className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
            >
              Home
            </NavLink>
            {/* <NavLink 
              to="/premium"
              onClick={closeMenu}
              className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
            >
              Premium
            </NavLink> */}
            <NavLink 
              to="/contact"
              onClick={closeMenu}
              className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
            >
              About Us
            </NavLink>
            <NavLink 
              to="/terms"
              onClick={closeMenu}
              className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
            >
              Terms
            </NavLink>
            <NavLink 
              to="/privacy"
              onClick={closeMenu}
              className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
            >
              Privacy
            </NavLink>
            
            <div className="store-badges">
              <a href="https://apps.apple.com/us/app/lutero/id6749874059" onClick={closeMenu}><img src={appStore} alt="App Store" /></a>
              <a href="https://play.google.com/store/apps/details?id=com.elexistech.lutero" onClick={closeMenu}><img src={googlePlay} alt="Google Play" /></a>
            </div>
          </div>
          
          <button
            type="button"
            className="hamburger"
            onClick={handleToggle}
            aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isOpen}
            aria-controls="nav-links"
          >
            <span className={`bar ${isOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isOpen ? 'open' : ''}`}></span>
          </button>
        </div>
      </nav>
  )
}

export default Navbar;